/** @format */

import Feature from '@common/prototypes/Feature/feature';

export default Feature;
